import { getDecodedStartappQuery } from './get-decoded-startapp-query';

// Приоритет: query > startapp.
// Standalone-боты получают URL-параметры из console.paysystem.io/short-urls,
// которые перезаписывают исходные. В этих случаях pdTma приходит из startapp.
export const resolvePdTma = (): string | null => {
  const fromQuery = new URLSearchParams(window.location.search).get('pdTma');
  if (fromQuery) return fromQuery;

  const fromStartapp = getDecodedStartappQuery()?.pdTma;
  return fromStartapp ?? null;
};
